import { useEffect, useState } from "react";
import SoftBox from "components/SoftBox";
import Loader from "examples/Loader";
import "./style.css";
import "./accountsPageCompact.css";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
import Tabs from "../components/Tabs";
// import ClaimRequest from "./components/Tabs/ClaimRequest";
import Tags from "./components/Tabs/Tags";
import NewTable from "./components/AccountTable";
import PageLayout from "examples/LayoutContainers/PageLayout";
import { Warning } from "@mui/icons-material";
import { useKnowledgeBase } from "context/knowledgebaseContext";
import PageTitle from "../components/PageTitle";
import toast from "react-hot-toast";

function Accounts() {
  const AppService = useAppServices();
  const [agency] = useAgencyInfo();
  const [tagsData, setTagsData] = useState([]);
  const [List, setList] = useState([]);
  const { knowledgeBase, loading } = useKnowledgeBase();
  // const [claimBusinessData, setClaimBusinessData] = useState([]);
  const [loader, setloader] = useState(true);
  const [showWarning, setShowWarning] = useState(false);
  const [show, setShow] = useState(false);
  const onLoad = async () => {
    const { response } = await AppService.accounts.GetAccountsForAgency({
      query: `agency_id=${agency._id}&tags=business`,
      toaster: false,
    });
    if (response) {
      setList(response?.data || []);
      setloader(false);
      const anyMissingPlan = response?.data.some(
        (biz) => biz?.plan_type === "premium" && (!biz?.business_plan?.plan_id || !biz?.plan)
      );
      setShowWarning(anyMissingPlan);
    } else {
      // A dropped request (or an expired token mid-session) must not wipe the
      // listings already on screen — keep them until a refresh actually answers.
      setloader(false);
      toast.error("Could not refresh business listings. Showing last loaded data.");
    }
  };

  // const getClaimeBusiness = async () => {
  //   const agencyId = agency?._id;
  //   const { response } = await AppService.claim_business.Get({
  //     query: `agency_id=${agencyId}`,
  //   });
  //   if (response) {
  //     setClaimBusinessData(response?.data ?? []);
  //   }
  // };

  async function fetchTags() {
    const response = await AppService.business_tags.get({
      query: `agency_id=${agency._id}`,
    });
    setTagsData(response?.response?.data || []);
  }

  useEffect(() => {
    onLoad();
    // getClaimeBusiness();
  }, []);

  return loader ? (
    <Loader />
  ) : (
    <>
      <style>
        {`
       .kb-help-text-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 8px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s ease;
}

.kb-help-text-btn:hover {
  background: #eef2ff;
  color: #2f80ed;
  border-color: #c7d2fe;
}

`}
      </style>
      <PageLayout>
        <SoftBox alignItems="center" className="sd-accounts sd-page">
          <div className="sd-accounts__header sd-page__header d-flex w-100 align-items-center">
            <PageTitle helpUrl={!loading && knowledgeBase?.business}>
              Businesses
            </PageTitle>

            {showWarning && (
              <div
                className="sd-accounts__warning"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  backgroundColor: "#ffe5e5",
                  color: "#d32f2f",
                  padding: "5px 12px",
                  borderRadius: "8px",
                  fontWeight: "500",
                  whiteSpace: "nowrap",
                }}
              >
                <Warning /> One or more premium accounts are not configured properly. Please assign
                a valid plan to all premium accounts to enable full functionality.
              </div>
            )}
            {/* {!agency?.wordpress_settings && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  backgroundColor: "#ffe5e5",
                  color: "#d32f2f",
                  padding: "5px 12px",
                  borderRadius: "8px",
                  fontSize: "16px",
                  fontWeight: "500",
                  whiteSpace: "nowrap",
                }}
              >
                <Warning /> You need to reinstall the app to apply the new menu builder changes.
              </div>
            )} */}
            {/* 
  <div className="w-25 text-end">
    <CreateModal products={products} apps={apps} handleRefresh={onLoad} />
  </div> 
  */}
          </div>
          <Tabs
            tabsData={[
              {
                label: `All Accounts (${List?.length})`,
                content: <NewTable data={List} onLoad={onLoad} type="all" />,
              },
              {
                label: `Premium Accounts (${
                  List?.filter((item) => item?.plan_type === "premium")?.length
                })`,
                content: (
                  <NewTable
                    onLoad={onLoad}
                    data={List?.filter((item) => item?.plan_type === "premium")}
                    type="premium"
                  />
                ),
              },
              {
                label: `Free Accounts (${
                  List?.filter((item) => item?.plan_type === "free")?.length
                })`,
                content: (
                  <NewTable
                    onLoad={onLoad}
                    data={List?.filter((item) => item?.plan_type === "free")}
                    FreeAccount={List?.filter((item) => item?.plan_type === "free")}
                    type="free"
                  />
                ),
              },
              // {
              //   label: `Claim Requests (${
              //     claimBusinessData?.filter(
              //       (item) => item?.request_type === "claim" && item.status === "pending"
              //     ).length || 0
              //   })`,
              //   content: <ClaimRequest type="claim" onLoad={onLoad} />,
              // },
              // {
              //   label: `New Business Requests (${
              //     claimBusinessData?.filter(
              //       (item) => item?.request_type === "new" && item.status === "pending"
              //     ).length
              //   })`,
              //   content: <ClaimRequest type="new" onLoad={onLoad} />,
              // },
              {
                label: `Listing labels (${tagsData?.length || 0})`,
                content: <Tags fetchData={fetchTags} tagsData={tagsData} />,
              },
            ]}
          />
        </SoftBox>
      </PageLayout>
    </>
  );
}

export default Accounts;
